<div class="setting">
  <div>
    <div class="h7">Campaign Hub</div>
    <p class="p5">Track and manage your campaigns</p>
  </div>
</div>

<app-tab-view
  [tabs]="dashboardTabs"
  [defaultActiveTab]="activeTab"
  (tabChange)="onTabChange($event)"
  [hideStatsLabel]="true"
  [hideStats]="hideStats"
  (hideStatsChange)="onHideStatsChange($event)"
>
  <!-- Tab Content -->
  <div class="tab-content-wrapper">
    <!-- New child components -->
    <div *ngIf="activeTab === 'Campaigns'" class="tab-panel">
      <app-campaign-metrics *ngIf="!hideStats"></app-campaign-metrics>
      <app-campaign-stats *ngIf="!hideStats"></app-campaign-stats>
      <app-campaign-header (createCampaign)="onCreateCampaign()"></app-campaign-header>

      <!-- Campaign Toolbar -->
      <app-campaign-toolbar
        *ngIf="originalCampaignCount > 0"
        [searchPlaceholder]="'Search for campaigns'"
        [selectedLocation]="selectedLocation"
        [activeFilters]="activeFilters"
        (searchChanged)="onSearchChange($event)"
        (viewChanged)="onViewChange($event)"
        (locationChanged)="onLocationChange($event)"
        (filterClicked)="onFilterClick()"
        (filtersApplied)="onFiltersApplied($event)"
        (locationSelectionFromModal)="onLocationSelectionFromModal($event)"
      >
      </app-campaign-toolbar>

      <!-- Campaign Table -->
      <app-campaign-table
        [campaigns]="campaigns"
        [loading]="isLoading"
        [filters]="currentFilters"
        [originalCampaignCount]="originalCampaignCount"
        [hasLoadedInitialCampaigns]="hasLoadedInitialCampaigns"
        [totalRecords]="totalRecords"
        (edit)="onEditCampaign($event)"
        (delete)="onDeleteCampaign($event)"
        (duplicate)="onDuplicateCampaign($event)"
        (addCampaign)="onCreateCampaign()"
      >
      </app-campaign-table>
    </div>

    <div *ngIf="activeTab === 'Segments'" class="tab-panel segemnts-tab">
      <app-segments-metrics *ngIf="!hideStats"></app-segments-metrics>
      <app-segments-header (createSegment)="onCreateSegment()"></app-segments-header>
      <app-segments-toolbar
        *ngIf="originalSegmentCount > 0"
        [searchPlaceholder]="'Search for segments.'"
        [selectedLocation]="selectedLocation"
        (searchChanged)="onSearchChange($event)"
        (locationChanged)="onLocationChange($event)"
        (locationSelectionFromModal)="onLocationSelectionFromModal($event)"
      >
      </app-segments-toolbar>
      <app-segments-table
        [segments]="segments"
        [loading]="isLoading"
        [originalSegmentCount]="originalSegmentCount"
        [hasLoadedInitialSegments]="hasLoadedInitialSegments"
        (edit)="onEditSegment($event)"
        (delete)="onDeleteSegment($event)"
        (duplicate)="onDuplicateSegment($event)"
        (addSegment)="onCreateSegment()"
        (pageChange)="onSegmentsPageChange($event)"
        (rowsPerPageChange)="onSegmentsRowsPerPageChange($event)"
        [totalRecords]="totalSegmentsRecords"
      >
      </app-segments-table>
    </div>
  </div>
</app-tab-view>

<!-- Add Segment Modal -->
<app-add-segment-modal
  *ngIf="showAddSegmentModal"
  [isEditMode]="isEditMode"
  [segmentToEdit]="segmentToEdit"
  (close)="onCloseAddSegmentModal()"
  (save)="onSaveSegment($event)"
>
</app-add-segment-modal>

<!-- Delete Segment Modal -->
<app-delete-segment-modal
  [visible]="showDeleteModal"
  [segment]="segmentToDelete"
  [loading]="isDeletingSegment"
  (close)="onCloseDeleteModal()"
  (confirm)="onConfirmDelete($event)"
>
</app-delete-segment-modal>
